import { batteryStrategies, batteryStrategyIcons, strategies, Strategy, strategyIcons } from '../types/models'
import { ChipSelector } from './atoms/ChipSelector'
import { useTranslation } from 'react-i18next'

export interface StrategySelectorProps {
  value?: Strategy
  onSelect: (strategy: Strategy) => void
  advanced?: boolean
  battery?: boolean
  /**
   * Offer the battery maintenance mode `BATTERY_MANUAL`. Battery appliances
   * only; it is hidden from ordinary users, who see the chip only when the
   * battery already is in that mode (so they can switch back).
   */
  allowManual?: boolean
}

export function StrategySelector(props: StrategySelectorProps): React.ReactElement {

  const { value, onSelect, advanced, battery, allowManual } = props
  const { t } = useTranslation()

  const availableStrategies: Strategy[] =
    battery
      ? (allowManual ? batteryStrategies : batteryStrategies.filter(s => s !== 'BATTERY_MANUAL'))
      : (
          advanced ? strategies.slice(1) : strategies.slice(1).filter(s => s !== 'AUTO' && s !== 'AVOID_EXPENSIVE')
        )

  return (
    <ChipSelector
      sx={{ mt: 1 }}
      items={
        availableStrategies.reduce((prev, cur) => ({ ...prev, [cur]: t(`Strategy-${cur}`) }), {})
      }
      icons={battery ? batteryStrategyIcons : strategyIcons}
      selected={value || null}
      onSelect={(value) => onSelect(value as Strategy)}
      onePerLine
      more={3}
    />
  )
}
